module.exports = __webpack_public_path__ + "img/zoom_logo.596c69f1.svg";